// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ry-z","tupacHeader":"sy-z","tupacHeader2":"ty-z","tupacMenu":"uy-z","tupacMenu2":"vy-z","tupacMain":"wy-z","tupacMain2":"xy-z"};